import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const AnalyticsPDGPage = lazy(() => import("@/pages/analytics/AnalyticsPDGPage"));
const BalanceMatierePage = lazy(() => import("@/pages/rapports/BalanceMatierePage"));
const MargesPage = lazy(() => import("@/pages/rapports/MargesPage"));
const FournisseursRapportPage = lazy(() => import("@/pages/rapports/FournisseursRapportPage"));
const ExportsPage = lazy(() => import("@/pages/rapports/ExportsPage"));
const VentesRapportPage = lazy(() => import("@/pages/rapports/VentesRapportPage"));
const CaisseRapportsArchivePage = lazy(() => import("@/pages/rapports/CaisseRapportsArchivePage"));
const MembresRapportPage = lazy(() => import("@/pages/rapports/MembresRapportPage"));
const RegieEvenementsRapportPage = lazy(() => import("@/pages/rapports/RegieEvenementsRapportPage"));
const PerformancesEquipePage = lazy(() => import("@/pages/rapports/PerformancesEquipePage"));
const AlertsHistoryPage = lazy(() => import("@/pages/manager/AlertsHistoryPage"));

export function rapportsRoutes() {
  return (
    <>
      <Route
        path="/analytics"
        element={
          <ProtectedRoute allowedRoles={["controleur", "pdg", "admin"]}>
            <AnalyticsPDGPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/balance"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <BalanceMatierePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/marges"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <MargesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/fournisseurs"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FournisseursRapportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/exports"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <ExportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/ventes"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="rapports.phase2"><VentesRapportPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/caisse"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="rapports.phase2"><CaisseRapportsArchivePage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/membres"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="rapports.phase2"><MembresRapportPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/regie-evenements"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="rapports.phase2"><RegieEvenementsRapportPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rapports/performances-equipe"
        element={
          <ProtectedRoute allowedRoles={["controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="rapports.phase2"><PerformancesEquipePage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manager/alertes"
        element={
          <ProtectedRoute allowedRoles={["chef_salle", "gerante", "pdg", "admin", "controleur"]}>
            <FeatureRoute flag="manager.realtime"><AlertsHistoryPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
    </>
  );
}
